export default {
  smartRouter: {
    helperText: {
      command: 'Enter a command...',
      command2:
        'Enter a command, ex: Send a text  message to John Doe next Saturday',
    },
  },
  smartNotes: {
    smartNotesHeading: 'Smart Notes',
  },
  header: {
    signOut: 'Sign out',
    manageGroups: 'Manage groups',
    labels: {
      manageGroupsContacts: 'Manage groups for selected contacts',
      email: 'Email',
      sms: 'Text Message',
    },
  },
  editor: {
    altEditor: {
      applyChangesButton: 'Apply Changes',
    },
    socialMedia: 'Apply Changes',
  },

  menuItems: {
    tasks: 'Tasks',
    emailTemplates: 'Email templates',
    forms: 'Forms',
    files: 'File Manager',
    contacts: 'Contacts',
    groups: 'Contact groups',
    knowledgeCenter: 'Knowledge Center',
    settingsPrefrences: 'Settings / Preferences',
  },
  general: {
    shared: {
      listView: 'Toggle list view',
      calendarView: 'Toggle calendar view',
      suggestions: 'Suggestions: ',
      selectGroup: 'Select contact group',
    },
    errors: {
      Four04:
        'Unfortunately the page you are requesting does not exist Error Code 404',
    },
  },
  onboarding: {
    stepsCompleted: 'All steps completed - you',
    stepsCompleted2: 're finished',
    reset: 'Reset',
    step: 'Step',
    alreadyCompleted: 'already completed',
    welcomeToVast: 'Welcome to Vast Reach!',
    completeSteps: 'Complete the steps below ',
    completeSteps2:
      'to fully setup your marketing funnel... Click here to hide/show the steps.',
    back: 'Back',
    next: 'Next',
  },
  accountSettings: {
    viewAll: {
      businessName: 'Business Name',
      belowEmails: 'Will appear at the bottom of all emails',
      mailingAddress: 'Mailing Address',
      sameAsBilling: 'Same as Billing',
      addressBelow: 'This address will appear at the bottom of all emails.',
      billingAddress: 'Billing Address',
      sameAsMailing: 'Same as Mailing',
      verifyPayment: 'Your Payment method will use this address to verify.',
      defaultEmailAddress: 'Default Email Address',
      allEmailsSent: 'By default, emails will be sent from ',
      defaultSmsNumber: 'Default Text Message Number ',
      allSmsSent: 'All Text Message will be sent from ',
      reCaptcha: 'ReCaptcha',
      reduceSpam: 'Reduce form submission spam by adding ReCaptcha!',
      reCaptchaType: 'Choose a ReCaptcha Type',
    },
    notification: {
      problem: 'Sorry we have encountered an error:',
      success: 'Your settings have been successfully changed',
    },
    labels: {
      addressLabel: 'Address',
      addressLabel2: 'Address Line 2',
      cityLabel: 'City',
      stateLabel: 'State',
      zipLabel: 'Zip',
      countryLabel: 'Country',
      secretKeyLabel: 'Secret Key',
      siteKeyLabel: 'Site Key',
      reCaptchaInvisible: 'Invisible',
      reCaptchaCheckbox: 'Checkbox',
    },
    helperText: {
      businessPlaceHolder: 'example: Vast Reach',
      addressPlaceHolder: 'example: 1 Citizens Bank Way',
      addressPlaceHolder2: 'example:  Popcorn Stand #1',
      cityPlaceHolder: 'example: Philadelphia',
      statePlaceHolder: 'example: PA',
      zipPlaceHolder: 'example: 19148',
      countryPlaceHolder: 'example: USA',
      emailPlaceHolder: 'example: no-reply@vastreach.com',
      smsPlaceHolder: 'example: +1234567890',
      secretKeyPlaceHolder: 'Add your ReCaptcha Secret Key',
      siteKeyPlaceHolder: 'Add your ReCaptcha Site Key',
    },
    toolTips: {
      saveSettings: 'Save Settings',
    },
    payment: {
      stepperToolTips: {
        paymentInfo:
          'This step allows you to manage your credit card payment information.',
        choosePlan:
          'This step allows you to manage your account subscription plan.',
        subscriptionDetails:
          'This step shows you your subscription details, your payment bill date, the amount due and your next bill amount.',
      },
    },
  },
  groups: {
    groupHeading: 'Contact Groups',
    groupName: 'Group name',
    contactName: 'Contact name',
    contactCount: 'Contact Count',
    noResults:
      'No groups to display. Please create a new group by clicking the button below.',
    addToGroup: 'Add to group',
    submit: 'Submit',
    createGroup: 'Add Group',
    renameGroup: 'Rename group',
    cancel: 'cancel',
    ok: 'ok',
    labels: {
      groupTitle: 'Group title',
    },
    toolTips: {
      edit: 'Edit',
      editGroup: 'Edit Group',
      deleteGroup: 'Delete Group',
      createGroup: 'Add group',
      message: 'Message',
      more: 'More',
    },
    placeholder: {
      contactToGroupPlaceholder: 'Add contacts to group ',
      enterGroupName: 'Enter a group name ',
    },
    groupCallToActions: {
      groupNameHeading: 'What should we call this group?',
      groupContactHeading: 'Who should we add to this group?',
    },
  },
  task: {
    taskHeader: 'TASKS',
    menuSort: {
      sort: 'Sort',
      oldestCreated: 'Oldest created first',
      newestCreated: 'Newest created first',
      newestSchedule: 'Newest scheduled first',
      oldestSchedule: 'Oldest scheduled first',
      mostOpens: 'Most opens',
      mostSends: 'Most sends',
      mostClicks: 'Most clicks',
      today: 'Today',
      Month: 'Month',
      Week: 'Week',
      Day: 'Day',
      noDisplay:
        'No tasks to display. Please click the button below to create a new task.',
      created: 'Created:',
    },
    viewAll: {
      stats: {
        emailOpens: 'Unique Email Open',
        uniqueClicks: 'Unique Email Click',
        smsDelivered: 'Total Text Message Delivered',
        totalSends: 'Total Email Send',
        smsSends: 'Total Text Message Send',
      },
    },
    add: {
      generalInfo: 'What should we call this task?',
      taskDescription: 'How should we describe this task?',
      taskType: 'What type of task should we create?',
      taskAutomation: 'How should we automate this task?',
      campaignSelect: 'What Campaign should we add this task to?',
      funnelSelect: 'What Funnel Stage should we add this task to?',
      groupSelect: 'What group should we select?',
      taskSend: 'When should we send this task?',
      delayTask: 'Delay your task',
      selectTaskType: 'Select a task type',
      blank: 'Blank',
      createBlank: 'Create a new E-mail template.',
      themes: 'Themes',
      createThemes: 'Select from a list of our industry leading themes.',
      templates: 'Templates',
      templatesCreate: 'Select from a list of your saved templates.',
      taskDetails: 'Task Details',
      createANewTask: 'Create a new task',
      taskTypeSelect: 'Choose a',
      taskTypeSelect2: 'Task Type',
      taskTypeSelect3:
        'on the right or start typing a description and watch the magic happen.',
      cancelButton: 'Cancel',
      delay: 'Delay',
      create: 'Create',
      next: 'Next',
      stageSelect: 'Select a stage',
      themeTemplate: 'Theme / Template',
      unSavedChanges: 'Discard unsaved changes?',
      edit: 'Edit',
      delete: 'Delete',
      header: {
        general: 'GENERAL',
        snippets: 'SNIPPETS',
        templateVariables: '{...} TEMPLATE VARIABLES',
      },
      toolTips: {
        general:
          'You will have the ability to edit the required task name to identify this task. You can write a description of what this task should look like and our AI will try to fill out as much of this task for you to minimize your workload. You can also select what task type this task will by selecting from the drop down menu. This section also allows you to select the automation type whether this task is a scheduled task, part of a campaign calendar or funnel. Lastly, you can select when to send this task out from the date and time picker. ',
        email:
          'You will be able to select who this email goes out to (groups and/or contacts). Entering the Template name will create a template of this email to be used when creating a new email from the template section. The subject of the email will be shown to the sender when they see this email in their inbox.',
        snippets:
          'Snippets are premade components that allow you to create emails faster. Dragging and dropping one into the email will let you select exactly where it goes. Alternatively, you can click a snippet and it will be added to the bottom of the preview window or you can click the ADD SECTION link at the bottom of the preview button and select a snippet from the list menu. Once a snippet has been placed down you can edit and customize it by clicking that snippet in the preview window.',
      },
      labels: {
        name: 'Name',
        description: 'Description',
        whenToSend: 'When To Send',
        templateName: 'Template Name',
        subject: 'Subject',
        createTask: 'Add Task',
      },
      helperText: {
        taskName: 'example: VIP Email',
        description: 'example: Send an email to the VIP Group next Thursday',
        groupName: 'Recipients (Groups and Contacts)',
        templateName:
          'Changing this template name will create a new template in the system',
        subject: 'Try something catchy. Avoid misleading subject lines 🙂',
        selectContacts: 'Select contacts',
        selectGroups: 'Select contact group to add to',
        selectGroupsToRemove: 'Select contact group to remove from',
        selectGroupsTo: 'Select contact groups to ',
        addTo: 'Add to ',
        removeFrom: 'Remove from ',
        selectACampaign: 'Select a campaign',
        timeUnits: 'Time units',
      },
      snippets: {
        description:
          'To add snippets to your email, click or drag a snippet feature below to add to the email.',
        header: 'Header',
        divider: 'Divider',
        paragraph: 'Paragraph',
        formLink: 'Form Link',
        button: 'Button',
        imageParagraph: 'Image + Paragraph',
        social: 'Social',
        twoColumns: '2 Columns (Image + Paragraph)',
        threeColumns: '3 Columns (Image + Paragraph)',
        imageBannerText: 'Image Banner + Text',
      },
      templateVariables: {
        variables: 'Merge fields',
        defaultValues: 'Default values for merge fields',
        description:
          'To add merge fields to your email, first select a place on the email preview on the left. Then click a variable below to add to the location you selected on the email.',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        number: 'Phone Number',
        email: 'Email Address',
        location: 'Location',
      },
      types: {
        email: 'Email',
        sms: 'Text Message',
        Notifications: 'Notification',
        addContactsGroup: 'Add Contacts to Group',
        scheduledHeading: 'Scheduled:',
        delayHeading: 'Delay:',
        removeContactsGroup: 'Remove Contacts from Group',
        contactBetweenGroups: 'Move Contact Between Groups',
      },
      emailFooter: {
        address:
          'Vast Reach Test Account, 538 Moreland Road  Huntingdon Valley, PA 19006 US',
        unsub: 'UNSUBSCRIBE',
        poweredBy: 'Powered By: ',
        notice1:
          'We will insert this footer into all your emails to conform to the',
        canSpam: 'CAN-SPAM Act',
        notice2:
          '. Any attempts to hide or remove this footer in any way whatsoever will be considered breach of our',
        termsService: 'terms of service.',
      },
      stepperToolTips: {
        task: 'This step allows you name this task to identify it, add a short description and select a task type to create.',
        automate:
          'This step allows you to select your automation preference using one of the following three ways: schedule when to send a task, adding this task directly into a campaign calendar or adding this task to a campaign funnel stage.',
        themeTemplate:
          'The Theme/Template step is only presented when using email task type. This step allows you to select between creating a blank email, a custom Vast Reach email theme or a previously created email theme.  ',
        finalize:
          'This step allows you to customize and finish creating your selected task type. ',
      },
    },
  },
  signupform: {
    edit: 'Edit',
    delete: 'Delete',
    embedForm: 'Embedded',
    popover: 'Popover',
    created: 'Created: ',
    createForm: 'Add Form',
    noFormDisplay:
      'No forms to display. Please click the button below to create a new form.',
    menuSort: {
      sort: 'Sort',
      nameAZ: 'Name (A-Z)',
      nameZA: 'Name (Z-A)',
      oldFirst: 'Oldest first',
      newFirst: 'Newest first',
    },
    viewAll: {
      stats: {
        totalResponses: 'Total Form Responses',
        totalVisits: 'Total Form Visits',
        totalForms: 'Total Forms',
      },
    },
    add: {
      responded: 'Responded',
      formTypeCallToAction: 'What type of form would you like to create?',
      groupCallToAction:
        'When a contact fills out the signup form they will be added to this group(s). This is optional.',
      chooseAField: 'Choose a field on the right to start building your form!',
      signUpForm: 'SIGNUP FORM',
      customForm: 'CUSTOM FORM',
      vastPixel: 'VAST PIXEL',
      responsesButton: 'Responses',
      embedButton: 'Embed / Share',
      previewButton: 'Preview',
      embedOnSite: 'Embed this form on your site',
      linkToForm: 'Link to this form',
      byoReCaptcha:
        'Note: If you are using a byo ReCaptcha, make sure that you add',
      byoReCaptcha2: 'to your domains.',
      byoReCaptcha3: 'Learn how!',
      copyClipboard: 'Copied to clipboard!',
      logoBrowse: 'Browse',
      discardChanges: 'Discard unsaved changes?',
      header: {
        general: 'GENERAL',
        form: 'FORM',
        fields: 'FIELDS',
        font: 'FONT',
        background: 'BACKGROUND',
        button: 'BUTTON',
        logo: 'LOGO',
        formTitle: 'Form title',
        description: 'Description',
      },
      toolTips: {
        desktopView: 'Desktop view',
        tabletView: 'Tablet View',
        phoneView: 'Phone View',
        form: 'You will have the ability to edit the required form name to identify this form. You will also be able to select the content group you would like to send this form to. Below the contact group are suggestions to your most used groups.',
        lookAndFeel:
          'The look and feel is separated by 5 tabs, each tab allows you customize a part of the form. The description lets you select the embed type, whether this form will be a pop-up or embedded on to a web page. The fields tab you can be add more fields and if they are required by the recipient to fill in. The following tabs (Description, Font, Background and Button) allows you to customize the cosmetic aspect of this form including font type, text color and background color.',
        logo: 'You can add your logo to the top of your forms by entering the URL of your logo or uploading it using our image manager.',
        requiredFields: 'Either email or phone is required',
      },
      labels: {
        formName: 'Form Name',
        embedType: 'Embed Type',
        title: 'Title',
        titleTextColor: 'Title Text Color',
        description: 'Description',
        descriptionTextColor: 'Description Text Color',
        availableFields: 'Available fields',
        required: 'Required',
        fontType: 'Font Type',
        textColor: 'Text Color',
        backgroundColor: 'Background Color',
        buttonText: 'Button Text',
        buttonTextColor: 'Button Text Color',
        buttonBackgroundColor: 'Button Background Color',
        embedForm: 'Embedded Form',
        popover: 'Popover',
      },
      helperText: {
        groupInfo:
          'When a contact fills out the signup form they will be added to this group(s). This is optional.',
      },
      responses: {
        totalResponses: 'Total Form Responses',
        totalVisits: 'Total Form Visits',
        noResponses: 'No responses yet!',
        exportButton: 'EXPORT',
        downloadButton: 'DOWNLOAD',
        printButton: 'PRINT',
      },
    },
    stepperToolTips: {
      form: 'This step allows you to name this form to identify it and select what type of form this will be (Sign-up Form, Custom Form or Vast Pixel).',
      build: 'This step allows you to customize and create your forms.',
      share:
        'Once a form has been created this step will be accessible. You can share or embed your form using the code snippets provided on this step.',
      analyze:
        'Once a form has been created this step will be accessible. This step allows you to monitor your contacts responses and statically information about this form.',
    },
  },
  templatePage: {
    viewAll: {
      loading: 'Loading...',
    },
    labels: {
      createTemplate: 'Add Template',
    },
    templateFormPage: {
      noResultsDisplay:
        'No templates to display. Please create a new template by clicking the button below.',
      editCodeDetails: 'Edit template details',
      editCode: 'Edit code',
      saveTemplate: 'Save template',
      general: 'GENERAL',
      createTemplate: 'Add template',
      helperText: {
        addTitle: 'Add a title for this template',
        subjectLine: 'Try something catchy. Avoid misleading subject lines 🙂',
      },
      toolTips: {
        generalToolTips:
          'You will have the ability to edit the required Template Name to identify this template. You will also have the ability to edit the required Subject Name to identify the subject of this email.  ',
        snippetToolTips:
          'Snippets are premade components that allow you to create emails faster. Dragging and dropping one into the email will let you select exactly where it goes. Alternatively, you can click a snippet and it will be added to the bottom of the preview window or you can click the ADD SECTION link at the bottom of the preview button and select a snippet from the list menu. Once a snippet has been placed down you can edit and customize it by clicking that snippet in the preview window.',
      },
    },
    stepperToolTips: {
      theme:
        'This step allows you to select the between a blank email and a custom Vast Reach email theme to start a template from.',
      design:
        'This step allows you to customize and create your email templates using Vast Reach’s theme editor.',
    },
  },
  emailPage: {
    noResultsDisplay: 'No results to display',
    scheduledEmails: 'Scheduled Emails',
    clearDate: 'Clear selected date',
    sentMessagesStats: 'Sent Messages and Stats',
    labels: {
      subject: 'Subject',
      sendEmail: 'Send email',
      scheduleEmail: 'Schedule email',
      dateSent: 'Date Sent',
      templateId: 'Template Id',
    },
    placeholder: {
      to: 'To: ',
    },
    toolTips: {
      viewSchedule: 'View scheduled email',
      cancelSchedule: 'Cancel scheduled email',
    },
  },
  smsPage: {
    labels: {
      sendText: 'Send text',
    },
  },
  contacts: {
    add: {
      name: 'Name',
      firstName: 'First Name',
      firstNameReg: 'First Name',
      middleName: 'Middle Name',
      lastName: 'Last Name',
      lastNameReg: 'Last Name',
      location: 'Location',
      notes: 'Notes',
      tasks: 'Tasks',
      groups: 'Groups',
      contactInfo: 'Contact Info',
      customAttributes: 'Custom Fields',
      newButton: 'NEW',
      mobileEmailButton: 'Email',
      mobilePhoneButton: 'Phone',
      addNewText: 'Add new',
      optInText: 'Opt in',
      optOutText: 'Opt out',
      mapCsv:
        'Map your CSV files contact fields to the Vast Fields to finish the import process',
      aiMatch: 'Ai will attempt to match your fields to the Vast Fields!',
      aiNote:
        'Note: First or Last Name is required A contact Method is required (email or phone)',
      fileProcessing:
        'We are now processing your file.  This may take a few minutes...',
      confidentMatch: 'Confident Match',
      semiConfidentMatch: 'Semi-Confident Match',
      noMatch: 'No Match',
      yourFields: 'Your Fields',
      vastFields: 'VAST Fields',
      csvFields: 'CSV Fields',
      sampleData: 'Sample data',
      submitFile: 'Submit Your File',
      dragDropFile:
        'Drag and Drop a file below to start the contact import process...',
      createGroups: 'Create a group from selected contacts',
      cancel: 'cancel',
      ok: 'ok',
      edit: 'Edit',
      message: 'Message',
      more: 'More',
      createAGroup: 'Create a group',
      emptyContact: 'You have no contacts, manually',
      emptyContact2: 'add a contact',
      emptyContact3: 'or',
      emptyContact4: 'upload a csv',
      emptyContact5: 'by clicking one of the buttons below.',
      createContact: 'Add Contact',
      bulkUpload: 'Bulk upload',
      addGroup: 'Add group',
      addToGroup: 'Add to group',
      emailPage: 'Email page',
      contactTask: {
        emailTaskBtton: 'EMAIL',
        smsTaskBtton: 'Text Message',
      },
      labels: {
        groupTitle: 'Group title',
        emailLabel: 'Email',
        smsLabel: 'Text Message',
      },
      helperText: {
        taskDescription:
          'Select a task below to begin a new task with this contact',
        groupDescription: 'You can add your contact to groups here',
        attributeDescription: 'You can add custom fields here',
      },
    },
  },
  campaign: {
    add: {
      calendar: 'Calendar',
      funnel: 'Funnel',
      addFunnelStage: 'ADD A FUNNEL STAGE',
      stageName: 'Enter a stage name.',
      deleteStage: 'Delete stage',
      newFunnelStageText: 'New Funnel Stage',
      campaignDeleteWarning: 'Are you sure you want to delete',
      campaignDeleteWarning2:
        '?' /*  This will also delete any tasks belonging to this stage' */,
      eventGoalsHeading: 'IF THIS HAPPENS',
      taskHeading: 'THEN DO THIS...',
      addEventGoalsButton: 'Add Event Goal',
      removeEventGoal: 'Remove event goal',
      addTaskButton: 'Add Task',
      editTask: 'Edit task',
      removeTask: 'Remove task',
      delay: 'Delay',
      campaignGeneralHeading: 'GENERAL',
      campaignTasksHeading: 'TASKS',
      campaignEventGoalsHeading: 'EVENT GOALS',
      campaignAutoTaskHeading: 'AUTOMATE YOUR TASKS',
      campaignScheduleTaskHeading: 'SCHEDULE YOUR TASKS',
      campaignDateRange: 'Add a date range?',
      eventGoalPaper: {
        eventGoalDescription: 'Drag and drop an',
        eventGoalDescription2: 'event',
        eventGoalDescription3: 'from below into a',
        eventGoalDescription4: 'stage',
        eventGoalDescription5: 'on the left to control when a',
        eventGoalDescription6: 'contact',
        eventGoalDescription7: 'moves to the next stage or leaves the funnel',
      },
      taskPaper: {
        taskDescription: 'Drag and drop a',
        taskDescription2: 'task type',
        taskDescription3: 'from below into the',
        taskDescription4: 'calendar',
        taskDescription5: 'on the left to scheduled when a',
        taskDescription6: 'task',
        taskDescription7: 'gets triggered.',
      },
      taskPaperFunnel: {
        taskDescription: 'Drag and drop a',
        taskDescription2: 'task type',
        taskDescription3: 'from below into a',
        taskDescription4: 'stage',
        taskDescription5: 'on the left. These',
        taskDescription6: 'tasks',
        taskDescription7: 'will fire in order when an',
        taskDescription8: ' event goal',
        taskDescription9: 'gets triggered.',
      },
      taskPaperList: {
        taskDescription0: 'Click a',
        taskDescription1: 'task type',
        taskDescription2: 'from below to schedule when a',
        taskDescription3: 'task',
        taskDescription4: 'gets triggered',
      },
      contactsInStage: {
        contactHeading: 'Contacts in stage',
        firstName: 'First Name',
        lastName: 'Last Name',
      },
      toolTips: {
        general:
          'You will have the ability to edit the required campaign name to identify this campaign. You can write a description of how this campaign should look like and our AI will try to build a layout of this campaign for you to minimize your workload. Lastly, you can select when to begin this campaign and when it will end by clicking the YES radio box and selecting your begin and end date. Alternatively, leaving the default date range at NO will make this campaign indefinite.',
        scheduleTasksCalendar:
          'When dragging and dropping a task into the Calendar on the left it will prompt a Task Creation modal. It is similar to creating a task through the task page but these tasks will show up directly in this campaign.',
        eventGoals:
          'After creating a stage then selecting that stage, clicking an event from this section will add the event to that stage. Alternatively, you can drag and drop an event to any stage even if it’s closed. When an event successfully happens it will trigger a task you have created in the task section below the event section.',
        scheduleTasksFunnel:
          'After creating a stage then selecting that stage, clicking a task from this section will add that task to that stage. Alternatively, you can drag and drop a task to any stage even if it’s closed. Tasks are triggered after an event you created successfully happens.',
      },
    },
    campaignStatus: {
      campaignPlay: 'Campaign is a work in progress. Press play to go live',
      campaignPause: 'Campaign is paused. Press play to go live',
      campaignLive: 'Campaign is live',
      campaignComplete: 'Campaign is complete',
      goLiveButton: 'Go Live',
      pauseButton: 'Pause campaign',
    },
    helperText: {
      campaignName: 'Enter a name for your campaign* (required)',
      campaignDescription:
        'Type in a description (e.g. A campaign with three stages: Contacts, Leads and Customer.)',
      sendRange: 'Tasks will send in this range only',
      infiniteRange: 'All tasks will start on this date, and run indefinitely',
      endRange: 'All tasks will end on this Date',
      indefiniteRange: 'This is an indefinite campaign',
      noResults: 'No results to display',
      editContact: 'Edit Contact',
      newStageName: 'New stage name',
      enterNewStageName: 'Enter a stage name to create a new stage',
      editCampaign: 'Edit campaign',
      deleteCampaign: 'Delete Campaign',
      createCampaign: 'Add Campaign',
    },
    labels: {
      startDate: 'Start Date',
      endDate: 'End date',
      name: 'Name',
      dateCreated: 'Date created',
      campaigns: 'Campaigns',
    },
    stepperToolTips: {
      campaign:
        'This step allows you to add a name to identify this campaign, a short description about it and select if you want a start and end date for this campaign.',
      calendar:
        'The Calendar step allows you to schedule your tasks to execute at a specific date and time.',
      funnel:
        'The Funnel step allows you to create a complex campaigns using event goals to trigger automated tasks and funnel your contacts through marketing stages.',
    },
  },
  managePhone: {
    noDisplay:
      'You have no phone numbers. Please add one by clicking the button below.',
    addNumber: 'ADD NUMBER',
    callForwardingNumber: 'Call forwarding number',
    phoneNumber: 'Phone number',
    defaultNumber: 'Assign this number to a user',
    manageNumbersTitle: 'Manage Phone Numbers',
    delete: 'Delete',
  },
  s3Manager: {
    defaultPath: 'Current Path: Home /',
    folderHeader: 'Folders',
    filesHeader: 'Files',
    organizeFilesPt1:
      'Organize your files by creating folders. Click the button above, type in a folder name and press enter.',
    organizeFilesPt2: 'button above.',
    createNewFolder: 'New Folder',
    typeFolderName: 'Type in folder name and then press enter.',
    deleteWarning: 'Are you sure you want to DELETE these file(s)?',
    moveWarning: 'Confirm MOVE of these file(s)',
    neverMind: 'Never Mind',
    confirm: 'Confirm',
    chooseDestination: 'Please Choose a destination',
    deleteConfirmText:
      'Type in the word "DELETE" in the field above and press "CONFIRM" to delete the files',
    moveConfirmText:
      'Type in the word "MOVE" in the field above and press "CONFIRM" to move the files',
    delete: 'Delete',
    move: 'Move',
    selectedFiles: 'Selected Files',
    noFileDisplay: 'You have not uploaded any files yet. Add files below.',
    fileName: 'File Name',
    lastModified: 'Last Modified',
    size: 'Size',
  },
};
